import React from "react";
import Navigation from "../Navigation/Navigation";
import "../Dashboard/Dashboard.css";

const PrivacyPolicy = () => {
  return (
      <div className="PrivacyPolicyMain">
        <h3>Privacy Policy</h3>
        <h5>This Privacy Policy was last revised on May 25, 2018.</h5>
        <br />
        <p>
          Meylah, Corp. (“Meylah,” “we,” or “us”) knows that you care how
          information about you is used and shared. This Privacy Policy explains
          what information of yours will be collected by Meylah when you use the
          Meylah Service, how the information will be used, and how you can
          control the collection, correction and/or deletion of information. We
          will not use or share your information with anyone except as described
          in this Privacy Policy. This Privacy Policy does not apply to
          information we collect by other means (including offline) or from
          other sources. Capitalized terms that are not defined in this Privacy
          Policy have the meaning given them in our Terms of Use.
        </p>
        <br />
        <h3>Information We Collect</h3>
        <p>
          User-Provided Information: You provide us information about yourself,
          such as your name and e-mail address, if you register for a Member
          account with the Service (including by “following,” “becoming a fan,”
          etc., of Meylah on a social network). If you correspond with us by
          email, we may retain the content of your email messages, your email
          address and our responses. We may also retain any messages you send
          through the Service. You may provide us information in User Content
          you post to the Service.
          <br />
          <br /> Cookies Information: When you visit the Service, we may send
          one or more cookies – a small text file containing a string of
          alphanumeric characters – to your computer that uniquely identifies
          your browser and lets Meylah help you log in faster and enhance your
          navigation through the site. A cookie may also convey anonymous
          information about how you browse the Service to us. A cookie does not
          collect personal information about you. A persistent cookie remains on
          your hard drive after you close your browser. Persistent cookies may
          be used by your browser on subsequent visits to the site. Persistent
          cookies can be removed by following your web browser’s directions. A
          session cookie is temporary and disappears after you close your
          browser. You can reset your web browser to refuse all cookies or to
          indicate when a cookie is being sent. However, some features of the
          Service may not function properly if the ability to accept cookies is
          disabled.
          <br />
          <br /> Log File Information: Log file information is automatically
          reported by your browser each time you access a web page. When you use
          the Service, our servers automatically record certain information that
          your web browser sends whenever you visit any website. These server
          logs may include information such as your web request, Internet
          Protocol (“IP”) address, browser type, referring / exit pages and
          URLs, number of clicks, domain names, landing pages, pages viewed, and
          other such information.
          <br />
          <br /> Clear Gifs Information: When you use the Service, we may employ
          clear gifs (also known as web beacons) which are used to track the
          online usage patterns of our users anonymously. No personally
          identifiable information from your Meylah account is collected using
          these clear gifs. In addition, we may also use clear gifs in
          HTML-based emails sent to our users to track which emails are opened
          by recipients. The information is used to enable more accurate
          reporting, improve the effectiveness of our marketing, and make Meylah
          better for our users.
        </p>
        <h3>How We Use Your Information</h3>
        <p>
          We use the personal information you submit to operate, maintain, and
          provide to you the features and functionality of the Service.
          <br />
          <br /> By providing Meylah your email address (including by
          “following,” “becoming a fan,” etc., of Meylah on a social network),
          you consent to our using the email address to send you Service-related
          notices, including any notices required by law, in lieu of
          communication by postal mail. You also agree that we may send you
          notifications of activity on the Service to the email address you give
          us, in accordance with any applicable privacy settings. We may use
          your email address to send you other messages, such as newsletters,
          changes to features of the Service, or special offers. If you do not
          want to receive such email messages, you may opt out by sending an
          email request to unsubscribe@meylah.com. Opting out may prevent you
          from receiving email messages regarding updates, improvements, or
          offers. You may not opt out of Service-related e-mails.
          <br />
          <br /> Following termination or deactivation of your Member account,
          Meylah may retain your profile information and User Content for a
          commercially reasonable time for backup, archival, or audit purposes.
          Furthermore, Meylah may retain and continue to use indefinitely all
          information (including User Content) contained in your communications
          to other Users or posted to public or semi-public areas of the Service
          after termination or deactivation of your Member account.
          <br />
          <br /> If you choose to use our invitation service to invite a friend
          to the Service, we will ask you for that person’s email address and
          automatically send an email invitation. Meylah stores this information
          to send this email, to register your friend if your invitation is
          accepted, and to track the success of our invitation service. Your
          friend may contact us to request that we remove this information from
          our database at privacy@meylah.com.
          <br />
          <br />
          Meylah may use certain information about you and/or your User Content
          internally for purposes such as analyzing how the Service is used,
          diagnosing service or technical problems, maintaining security, and
          personalizing content.
          <br />
          <br /> Meylah reserves the right, but has no obligation, to monitor
          the User Content you post on the Service. We reserve the right to
          remove any such information or material for any reason or no reason,
          including without limitation if in our sole opinion such information
          or material violates, or may violate, any applicable law or our Terms
          of Use Agreement, or to protect or defend our rights or property or
          those of any third party.
          <br />
          <br /> Meylah also reserves the right to remove information upon the
          request of any third party. We use cookies, clear gifs, and log file
          information to: (a) remember information so that you will not have to
          re-enter it during your visit or the next time you visit the site; (b)
          provide custom, personalized content and information; (c) monitor the
          effectiveness of our Service; (d) monitor aggregate metrics such as
          total number of visitors, traffic, and demographic patterns; (e)
          diagnose or fix technology problems reported by our Users or engineers
          that are associated with certain IP addresses; (f) help you
          efficiently access your information after you sign in; and (h) track
          User Content and Users to the extent necessary to comply as a service
          provider with the Digital Millennium Copyright Act.
        </p>
        <h3>How We Share Your Information</h3>
        <p>
          Personally Identifiable Information: Meylah will not rent or sell your
          personally identifiable information to others. Meylah may share your
          personally identifiable information with third parties for the purpose
          of providing the Service to you. If we do this, such third parties’
          use of your information will be bound by this Privacy Policy. We may
          store personal information in locations outside the direct control of
          Meylah (for instance, on servers or databases co-located with hosting
          providers).
          <br />
          <br /> As we develop our business, we may buy or sell assets or
          business offerings. Customer, email, and visitor information is
          generally one of the transferred business assets in these types of
          transactions. We may also transfer or assign such information in the
          course of corporate divestitures, mergers, or dissolution.
          <br />
          <br /> Any personal information or content that you voluntarily
          disclose for posting to the Service, such as User Content, becomes
          available to the public, as controlled by any applicable privacy
          settings. If you remove information that you posted to the Service,
          copies may remain viewable in cached and archived pages of the
          Service, or if other Users have copied or saved that information.
          <br />
          <br /> From time to time, we may run contests, special offers, or
          other events or activities (“Events”) on the Service together with a
          third party partner. If you provide information to such third parties,
          you give them permission to use it for the purpose of that Event and
          any other use that you approve. We cannot control third parties’ use
          of your information. If you do not want your information to be
          collected by or shared with a third party, you can choose not to
          participate in these Events.
          <br />
          <br /> Except as otherwise described in this Privacy Policy, Meylah
          will not disclose personal information to any third party unless
          required to do so by law or subpoena or if we believe that such action
          is necessary to (a) conform to the law, comply with legal process
          served on us or our affiliates, or investigate, prevent, or take
          action regarding suspected or actual illegal activities; (b) to
          enforce our Terms of Use, take precautions against liability, to
          investigate and defend ourselves against any third-party claims or
          allegations, to assist government enforcement agencies, or to protect
          the security or integrity of our site; and (c) to exercise or protect
          the rights, property, or personal safety of Meylah, our Users or
          others.
          <br />
          <br />
          Non-Personally Identifiable Information: We may share non-personally
          identifiable information (such as anonymous usage data, referring/exit
          pages and URLs, platform types, number of clicks, etc.) with
          interested third parties to help them understand the usage patterns
          for certain Meylah services.
          <br />
          <br /> Meylah may allow third-party ad servers or ad networks to serve
          advertisements on the Service. These third-party ad servers or ad
          networks use technology to send, directly to your browser, the
          advertisements and links that appear on Meylah. They automatically
          receive your IP address when this happens. They may also use other
          technologies (such as cookies, JavaScript, or web beacons) to measure
          the effectiveness of their advertisements and to personalize the
          advertising content. Meylah does not provide any personally
          identifiable information to these third-party ad servers or ad
          networks without your consent. However, please note that if an
          advertiser asks Meylah to show an advertisement to a certain audience
          and you respond to that advertisement, the advertiser or ad server may
          conclude that you fit the description of the audience they are trying
          to reach. In addition, third-party advertisers may use information
          (not including your name, address, email address, or telephone number)
          about your visits to this and other websites in order to provide
          advertisements about goods and services of interest to you. If you
          would like more information about this practice and to know your
          choices about not having this information used by these companies,
          click here http://www.google.com/privacy_ads.html for Google or
          http://networkadvertising.org/managing/opt_out.asp for a number of
          advertisers including Google. The Meylah Privacy Policy does not apply
          to, and we cannot control the activities of, third-party advertisers.
          Please consult the respective privacy policies of such advertisers for
          more information.
        </p>
        <h3>How We Protect Your Information</h3>
        <p>
          Meylah uses commercially reasonable physical, managerial, and
          technical safeguards to preserve the integrity and security of your
          personal information and implement your privacy settings. We cannot,
          however, ensure or warrant the security of any information you
          transmit to Meylah or guarantee that your information on the Service
          may not be accessed, disclosed, altered, or destroyed by breach of any
          of our physical, technical, or managerial safeguards. Your privacy
          settings may also be affected by changes to the functionality of
          Meylah’s distributors, such as social networks. Meylah is not
          responsible for the functionality or security measures of any third
          party.
          <br />
          <br /> To protect your privacy and security, we take reasonable steps
          (such as requesting a unique password) to verify your identity before
          granting you access to your account. You are responsible for
          maintaining the secrecy of your unique password and account
          information, and for controlling access to your email communications
          from Meylah, at all times.
        </p>
        <h3>Compromise of Personal Information</h3>
        <p>
          In the event that personal information is compromised as a result of a
          breach of security, Meylah will promptly notify those persons whose
          personal information has been compromised, in accordance with the
          notification procedures set forth in this Privacy Policy, or as
          otherwise required by applicable law.
        </p>
        <h3>Your Choices About Your Information</h3>
        <p>
          You may, of course, decline to submit personally identifiable
          information through the Service, in which case Meylah may not be able
          to provide certain services to you. Members may update or correct
          their account information and email preferences at any time by logging
          in to their account and changing their preferences. You can review and
          correct the information about you that Meylah keeps on file by
          contacting us directly at support@meylah.com.
        </p>
        <h3>Children’s Privacy</h3>
        <p>
          Protecting the privacy of young children is especially important. For
          that reason, Meylah does not knowingly collect or solicit personal
          information from anyone under the age of 13 or knowingly allow such
          persons to register as Members. If you are under 13, please do not
          send any information about yourself to us, including your name,
          address, telephone number, or email address. No one under age 13 is
          allowed to provide any personal information to or on Meylah. In the
          event that we learn that we have collected personal information from a
          child under age 13 without verification of parental consent, we will
          delete that information as quickly as possible. If you believe that we
          might have any information from or about a child under 13, please
          contact us at privacy@meylah.com.
        </p>
        <h3>Links to Other Web Sites</h3>
        <p>
          We are not responsible for the practices employed by websites linked
          to or from the Service, nor the information or content contained
          therein. Please remember that when you use a link to go from the
          Service to another website, our Privacy Policy is no longer in effect.
          Your browsing and interaction on any other website, including those
          that have a link on our website, is subject to that website’s own
          rules and policies. Please read over those rules and policies before
          proceeding.
        </p>
        <h3>Notification Procedures</h3>
        <p>
          It is our policy to provide notifications, whether such notifications
          are required by law or are for marketing or other business related
          purposes, to you via email notice, written or hard copy notice, or
          through conspicuous posting of such notice on the Service, as
          determined by Meylah in its sole discretion. We reserve the right to
          determine the form and means of providing notifications to you,
          provided that you may opt out of certain means of notification as
          described in this Privacy Policy.
        </p>
        <h3>Changes to Our Privacy Policy</h3>
        <p>
          If we change our privacy policies and procedures, we will post those
          changes on the Service to keep you aware of what information we
          collect, how we use it and under what circumstances we may disclose
          it. Changes to this Privacy Policy are effective when they are posted
          on this page.
          <br />
          <br />
          If you have any questions about this Privacy Policy, the practices of
          this site, or your dealings with this website, please contact us at
          privacy@meylah.com, or send mail to:
          <br />
          <br /> Meylah, Corp.
          <br /> 3020 Issaquah-Pine Lake Road SE,
          <br /> PMB 540
          <br /> Sammamish, WA 98074
        </p>
        <h3>GDPR Terms</h3>
        <p>
          The terms and provisions only apply to EEA Residents and only to the
          extent that we are subject to the European Union’s General Data
          Protection Regulation (“GDPR”). If there is any conflict between the
          GDPR Terms and the rest of this Privacy Policy, the GDPR Terms shall
          control with respect to EEA Residents (and only to the extent that we
          are subject to GDPR). Our identity and contact information is as
          follows:
          <br />
          <br />
          <span className="PPspan">
            Meylah, Corp, a Delaware Corporation
            <br /> 3020 Issaquah-Pine Lake Road SE,
            <br />
            PMB 540
            <br /> Sammamish, WA 98074
            <br /> support@meylah.com
            <br />
            <br />
          </span>
        </p>
        <p>
          We rely on the following legal grounds to process your personal
          information:
          <br />
          <br />
        </p>
        <ul>
          <li>
            <span className="PPspan"> Consent.</span> We may use your personal
            information as described in this Privacy Policy subject to your
            consent. To withdraw your consent, please contact us at
            [support@meylah.com].
          </li>
          <li>
            <span className="PPspan">Performance of a contract.</span> We may
            need to collect and use your personal information, as applicable, to
            perform our contractual obligations.
          </li>
          <li>
            <span className="PPspan">Legitimate Interests.</span> We may use
            your personal information for our legitimate interests to provide
            our products, our partners’ products, and our services and to
            improve our services and the content on the Website. We may use
            technical information as described in this Privacy Policy and use
            personal information for our marketing purposes consistent with our
            legitimate interests and any choices that we offer or consents that
            may be required under applicable law.
          </li>
          <li>
            <span className="PPspan">Legal Compliance.</span> We may collect and
            use your information in connection with legal obligations to which
            we are subject. These legal obligations include, but are not limited
            to, any and all applicable (i) federal, state, or local laws, rules,
            or regulations, (ii) court orders, or (iii) consent decrees.
          </li>
        </ul>
        <p>
          We may use information that we collect about you, including personal
          information, to:
          <br />
          <br />
        </p>
        <ul>
          <li>
            <span className="PPspan"> Provide Products and Services.</span> We
            will use your information to provide our products, our partner’s
            products, and our services to you; to respond to your inquiries; and
            for other customer service and support purposes. We use the payment
            information you provide to us in order to alert you of past,
            current, and upcoming charges, to allow us to present the purchase
            history to you, and to perform internal finance processes, such as
            looking the status of a credit card charge. In the event of a credit
            card dispute, we also share account information with your bank to
            verify the legitimacy of a charge.
          </li>
          <li>
            <span className="PPspan">Understand and improve our products.</span>{" "}
            We will perform research and analysis about your use of, or interest
            in, our products, our partner’s products, our services, or content,
            or products, services or content offered by others. We do this to
            help make our products better and to develop new products.
          </li>
          <li>
            <span className="PPspan">Legitimate Interests.</span> We may use
            your personal information for our legitimate interests to provide
            our products, our partners’ products, and our services and to
            improve our services and the content on the Website. We may use
            technical information as described in this Privacy Policy and use
            personal information for our marketing purposes consistent with our
            legitimate interests and any choices that we offer or consents that
            may be required under applicable law.
          </li>
          <li>
            <span className="PPspan">Legal Compliance.</span> We may collect and
            use your information in connection with legal obligations to which
            we are subject. These legal obligations include, but are not limited
            to, any and all applicable (i) federal, state, or local laws, rules,
            or regulations, (ii) court orders, or (iii) consent decrees.
          </li>
        </ul>
      </div>
  );
};

export default PrivacyPolicy;
